import { Mail, Truck, Shield, Check } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { LucideIcon } from "lucide-react"

interface PricingTier {
  id: string
  title: string
  price: number
  description: string
  features: string[]
  icon: LucideIcon
  priceId: string
}

interface PricingTiersProps {
  onSelect: (method: string) => void
}

const pricingTiers: PricingTier[] = [
  {
    id: "email",
    title: "Email Delivery",
    price: 5,
    description: "Your Cease and Desist letter is placed on our official letterhead and delivered via email.",
    icon: Mail,
    priceId: "price_1QpHMnLBB8IUFcuXIQuq9OcT",
    features: [
      "Professional letter template",
      "AI-powered customization",
      "Same day delivery",
      "Digital copy for your records"
    ]
  },
  {
    id: "standard",
    title: "Standard Mail",
    price: 10,
    description: "Your Cease and Desist letter is printed on our official letterhead and delivered via standard USPS.",
    icon: Truck,
    priceId: "price_1QpHOeLBB8IUFcuXjxC6n0Dh",
    features: [
      "Professional letter template",
      "AI-powered customization",
      "Printed on premium letterhead",
      "Standard USPS delivery",
      "Digital copy for your records"
    ]
  },
  {
    id: "certified",
    title: "Certified Mail",
    price: 15,
    description: "Your Cease and Desist letter is printed on our official letterhead and delivered via USPS Certified Mail.",
    icon: Shield,
    priceId: "price_1QpHPvLBB8IUFcuX2LJm4Y37",
    features: [
      "Professional letter template",
      "AI-powered customization",
      "Printed on premium letterhead",
      "USPS Certified Mail® with tracking",
      "Delivery confirmation",
      "Digital copy for your records"
    ]
  }
]

export function PricingTiers({ onSelect }: PricingTiersProps) {
  return (
    <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
      {pricingTiers.map((tier) => (
        <Card key={tier.id} className="relative flex flex-col border-2 hover:border-[#29b554] transition-colors">
          <div className="p-6">
            <h3 className="text-2xl font-bold text-[#18375d]">{tier.title}</h3>
            <div className="mt-4 flex items-baseline">
              <span className="text-4xl font-bold tracking-tight text-[#18375d]">
                ${tier.price}
              </span>
            </div>
            <p className="mt-3 text-[#18375d]/70">{tier.description}</p>
            <ul className="mt-6 space-y-4">
              {tier.features.map((feature) => (
                <li key={feature} className="flex items-start">
                  <Check className="h-5 w-5 text-[#29b554] shrink-0" />
                  <span className="ml-3 text-[#18375d]/70">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="p-6 mt-auto">
            <Button
              className="w-full bg-[#29b554] hover:bg-[#29b554]/90"
              onClick={() => onSelect(tier.id)}
            >
              Choose Delivery Method
            </Button>
          </div>
        </Card>
      ))}
    </div>
  )
}
